import { defineLocalStore } from '@/utils/localStore'
import { ref } from 'vue'
import { userActivate, userDeactivate } from '@/requests/user'

export const {
  useLocalStore: useUserCardGeneralStore,
  initLocalStore: initUserCardGeneralStore,
} = defineLocalStore('userCardGeneral', (core: any) => {
  const changePassword = ref(false)

  const toggleChangePassword = () => {
    if (core.readonly.value) return

    if (changePassword.value) {
      delete core.user.password
    }

    changePassword.value = !changePassword.value
  }

  const handleActive = (isActive: boolean) => {
    if (core.readonly.value) return

    const request = isActive ? userActivate : userDeactivate

    return request(core.user.id).catch(() => {
      core.user.isActive = !isActive
    })
  }

  return {
    changePassword,
    handleActive,
    toggleChangePassword,
  }
})
